module.exports = __webpack_public_path__ + "static/media/214x152_1 copy.d5c0431f.png";